import publicConfig from "config/public";

const {
  imgix: { directusUrl },
} = publicConfig;

export default (fileName: string) => `${directusUrl}/${fileName}`;
